import { render, staticRenderFns } from "./HolidaysChildrenForm.vue?vue&type=template&id=2434f3e1&"
import script from "./HolidaysChildrenForm.vue?vue&type=script&lang=js&"
export * from "./HolidaysChildrenForm.vue?vue&type=script&lang=js&"
import style0 from "./HolidaysChildrenForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports